var map = {
	"./AddPunchoutIdentityPage.tsx": 62251,
	"./CustomerRegistrationPage.tsx": 36703,
	"./PunchoutIdentityPage.tsx": 19730,
	"./PunchoutSecretPage.tsx": 4684
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 96262;